<template>
    <div class="order-detail-wrap">
        <h1 class="detail-title">{{$t('moduleTitles.orderInfo')}}</h1>
        <div class="detail-content">
            <a-row>
                <!-- 訂單號 -->
                <a-col :xs="24" :sm="24" :xl="24">
                    <div class="list">
                        <label>{{$t('table.order.thead.order_sn')}}</label>
                        <div class="con">{{detailData.order_sn}}</div>
                    </div>
                </a-col>
                <!-- 訂單描述 -->
                <a-col :xs="24" :sm="24" :xl="12">
                    <div class="list">
                        <label>{{$t('table.order.thead.order_subject')}}</label>
                        <div class="con">
                            {{detailData.order_subject}}
                            <span v-if="detailData.type==2">{{detailData.extra}}{{$t('message.orderExtraMessage')}}</span>
                            <span v-if="detailData.type==3">{{detailData.extra}}G</span>
                        </div>
                    </div>
                </a-col>
                <!-- 用戶信息 -->
                <a-col :xs="24" :sm="24" :xl="12">
                    <div class="list">
                        <label>{{$t('table.order.thead.user_name')}}</label>
                        <div class="con">{{detailData.name}}&nbsp;&nbsp;<span class="tips">{{detailData.phone}}</span></div>
                    </div>
                </a-col>
                <!-- 金額 -->
                <a-col :xs="24" :sm="24" :xl="12">
                    <div class="list">
                        <label>{{$t('table.order.thead.amount')}}</label>
                        <div class="con">{{detailData.amount}}</div>
                    </div>
                </a-col>
                <!-- 狀態 -->
                <a-col :xs="24" :sm="24" :xl="12">
                    <div class="list">
                        <label>{{$t('table.common.thead.status')}}</label>
                        <div class="con">{{detailData.status?$t('enum.payStatus.1'):$t('enum.payStatus.2')}}</div>
                    </div>
                </a-col>
                <!-- 付款類型 -->
                <a-col :xs="24" :sm="24" :xl="12">
                    <div class="list">
                        <label>{{$t('table.order.thead.pay_type')}}</label>
                        <div class="con">{{detailData.pay_type ? $t(`enum.payType.${detailData.pay_type}`) : ''}}</div>
                    </div>
                </a-col>
                <!-- 是否分期 -->
                <a-col :xs="24" :sm="24" :xl="12">
                    <div class="list">
                        <label>{{$t('member.isiNstalment')}}</label>
                        <div class="con">
                            <span v-if="detailData.instalment_id > 1 && detailData.instalment_id < 5">
                                {{$t('member.yes')}}&nbsp;&nbsp;&nbsp;{{detailData.type_text}}&nbsp;&nbsp;&nbsp;{{detailData.interest}}
                            </span>
                            <span v-else>{{$t('member.no')}}</span>
                        </div>
                    </div>
                </a-col>
                <!-- 創建時間 -->
                <a-col :xs="24" :sm="24" :xl="12">
                    <div class="list">
                        <label>{{$t('table.common.thead.createTime')}}</label>
                        <div class="con">{{detailData.create_time}}</div>
                    </div>
                </a-col>
                <!-- 付款時間 -->
                <a-col :xs="24" :sm="24" :xl="12">
                    <div class="list">
                        <label>{{$t('table.order.thead.confirm_time')}}</label>
                        <div class="con">{{detailData.confirm_time && detailData.confirm_time.indexOf('00:00:00') == -1 ? detailData.confirm_time : '--'}}</div>
                    </div>
                </a-col>
            </a-row>
        </div>
        <h1 class="detail-title mar-top20" v-if="detailData.invoice_consultation && Object.keys(detailData.invoice_consultation).length">{{$t('moduleTitles.invoiceiInfo')}}</h1>
        <div class="detail-content" v-if="detailData.invoice_consultation && Object.keys(detailData.invoice_consultation).length">
            <a-row>
                <!-- 發票類型 -->
                <a-col :xs="24" :sm="24" :xl="24">
                    <div class="list">
                        <label>{{$t('form.invoice.invoiceType')}}</label>
                        <div class="con">{{detailData.invoice_consultation && $t(`form.invoice.type.${detailData.invoice_consultation.type}`)}}</div>
                    </div>
                </a-col>
                <!-- 公司抬頭 -->
                <a-col :xs="24" :sm="24" :xl="12" v-if="detailData.invoice_consultation && detailData.invoice_consultation.type == 2">
                    <div class="list">
                        <label>{{$t('form.invoice.head.label')}}</label>
                        <div class="con">{{detailData.invoice_consultation && detailData.invoice_consultation.company_name}}</div>
                    </div>
                </a-col>
                <!-- 統一編碼 -->
                <a-col :xs="24" :sm="24" :xl="12" v-if="detailData.invoice_consultation && detailData.invoice_consultation.type == 2">
                    <div class="list">
                        <label>{{$t('form.invoice.code.label')}}</label>
                        <div class="con">{{detailData.invoice_consultation && detailData.invoice_consultation.identifier}}</div>
                    </div>
                </a-col>
                <!-- 發票類型 -->
                <a-col :xs="24" :sm="24" :xl="24">
                    <div class="list">
                        <label>{{$t('form.invoice.email.label')}}</label>
                        <div class="con">{{detailData.invoice_consultation && detailData.invoice_consultation.email}}</div>
                    </div>
                </a-col>
                <!-- 發票狀態 -->
                <a-col :xs="24" :sm="24" :xl="24">
                    <div class="list">
                        <label>{{$t('table.common.thead.status')}}</label>
                        <div class="con">{{detailData.invoice_consultation && $t(`form.invoice.status.${detailData.invoice_consultation.status}`)}}</div>
                    </div>
                </a-col>
                <!-- 發票號碼 -->
                <a-col :xs="24" :sm="24" :xl="12" v-if="detailData.invoice_consultation && detailData.invoice_consultation.status == 1">
                    <div class="list">
                        <label>{{$t('form.invoice.invoiceNo')}}</label>
                        <div class="con">{{detailData.invoice_consultation && detailData.invoice_consultation.invoice_no}}</div>
                    </div>
                </a-col>
                <!-- 開票時間 -->
                <a-col :xs="24" :sm="24" :xl="12" v-if="detailData.invoice_consultation && detailData.invoice_consultation.status == 1">
                    <div class="list">
                        <label>{{$t('form.invoice.invoiceTime')}}</label>
                        <div class="con">{{detailData.invoice_consultation && detailData.invoice_consultation.invoice_time}}</div>
                    </div>
                </a-col>
                <!-- 按鈕 -->
                <a-col :xs="24" :sm="24" :xl="12" v-if="userInfo.type == 1 && detailData.invoice_consultation && detailData.invoice_consultation.status == 0">
                    <div class="list">
                        <a-button class="invoicing-btn" type="primary" @click="invoicing">{{$t('form.invoice.invoicing')}}</a-button>
                    </div>
                </a-col>
            </a-row>
        </div>
        <h1 class="detail-title mar-top20" v-if="detailData.order_address && Object.keys(detailData.order_address).length">{{$t('moduleTitles.receivingInfo')}}</h1>
        <div class="detail-content" v-if="detailData.order_address && Object.keys(detailData.order_address).length">
            <a-row>
                <!-- 收貨人 -->
                <a-col :xs="24" :sm="24" :xl="12">
                    <div class="list">
                        <label>{{$t('form.receiving.name.label')}}</label>
                        <div class="con">{{detailData.order_address.name}}</div>
                    </div>
                </a-col>
                <!-- 聯繫手機 -->
                <a-col :xs="24" :sm="24" :xl="12">
                    <div class="list">
                        <label>{{$t('form.receiving.phone.label')}}</label>
                        <div class="con">{{detailData.order_address.phone}}</div>
                    </div>
                </a-col>
                <!-- 收貨地址 -->
                <a-col :xs="24" :sm="24" :xl="24">
                    <div class="list">
                        <label>{{$t('form.receiving.address.label')}}</label>
                        <div class="con">{{detailData.order_address.address}}</div>
                    </div>
                </a-col>
            </a-row>
        </div>
        <h1 class="detail-title mar-top20" v-if="detailData.order_work && Object.keys(detailData.order_work).length">{{$t('moduleTitles.workUpgradeInfo')}}</h1>
        <div class="detail-content" v-if="detailData.order_work && Object.keys(detailData.order_work).length">
            <a-row>
                <!-- 作品名稱 -->
                <a-col :xs="24" :sm="24" :xl="12">
                    <div class="list">
                        <label>{{$t('form.workUpgrade.wname.label')}}</label>
                        <div class="con">{{detailData.order_work.wname}}</div>
                    </div>
                </a-col>
                <!-- 上傳狀態 -->
                <a-col :xs="24" :sm="24" :xl="12">
                    <div class="list">
                        <label>{{$t('form.workUpgrade.status.label')}}</label>
                        <div v-if="detailData.order_work.status == 1" class="con">{{$t('form.workUpgrade.status.done')}}</div>
                        <div v-if="detailData.order_work.status == 2" class="con">{{$t('form.workUpgrade.status.doing')}}</div>
                        <div v-if="detailData.order_work.status == 3" class="con">{{$t('form.workUpgrade.status.fail')}}</div>
                        <div v-if="detailData.order_work.status == 0" class="con">{{$t('form.workUpgrade.status.undo')}}</div>
                    </div>
                </a-col>
                <!-- 按鈕 -->
                <a-col :xs="24" :sm="24" :xl="12" v-if="userInfo.type == 1 && detailData.order_work.wid_status == 1">
                    <div class="list">
                        <a-button class="invoicing-btn" type="primary" @click="download">{{$t('form.workUpgrade.download.label')}}</a-button>
                    </div>
                </a-col>
                <!-- 上傳 -->
                <a-col :xs="24" :sm="24" :xl="12" v-if="userInfo.type == 1 && detailData.order_work.wid_status == 1">
                    <div class="list">
                        <DragUploader ref="uploader" uptype="modelsZip" :callback="getUploader" >
                            <a-button class="invoicing-btn" type="primary" slot="body" :disabled="detailData.order_work.status == 2">{{$t('form.workUpgrade.upload.label')}}</a-button>
                        </DragUploader>
                    </div>
                </a-col>
            </a-row>
        </div>
    </div>
</template>

<script>
    import { findOrderDetail,writeInvoice } from "@/api/order";
    import { addWork3D } from "@/api/work";
    import { downloadFile1 } from "@/utils/downloadFile.js";
    import {mapState} from "vuex";
    import DragUploader from "@/components/DragUploader";
    export default {
        components: {DragUploader},
        name: "Detail",
        computed: {
            orderId: {
                get() {
                    if (this.$route.query.id != undefined) {
                        return parseInt(this.$route.query.id);
                    }
                    return 0;
                },
            },
            ...mapState({
                userInfo: (state) => state.user.userInfo,
            }),
        },
        data(){
            return{
                detailData: {}
            }
        },
        mounted() {
            this.loadData()
        },
        methods:{
            //加載數據
            loadData(){
                findOrderDetail({id: this.orderId}).then(res=>{
                    if(res.code == 1){
                        this.detailData = res.data
                    }
                }).catch(err=>{
                    console.log(err)
                })
            },
            //開票
            invoicing(){
                console.log('orderId',this.orderId)
                let self = this
                this.$confirm({
                    title: self.$t('moduleTitles.hintMessage'),
                    content: self.$t('form.invoice.tipMsg'),
                    onOk() {
                        writeInvoice({id: self.orderId}).then(res=>{
                            if(res.code == 1){
                                self.detailData = res.data
                                self.$message.success(res.message,1)
                                setTimeout(()=>{
                                    self.loadData()
                                },1000)
                            }
                        }).catch(err=>{
                            console.log(err)
                        })
                    },
                    onCancel() {},
                });
            },
            //下載作品全景圖
            download(){
                let data = [];
                for (let i = 0; i < this.detailData.order_work.scenes.length; i++) {
                    const scenes = this.detailData.order_work.scenes[i];
                    const scenesname = this.detailData.order_work.scenesname[i];
                    data.push({scenes, scenesname});
                }
                downloadFile1(data, this.detailData.order_work.wname);
            },
            //回調方法，up為上傳實例對像
            getUploader: function (up) {
                let _this = this;
                // _this.detailData.order_work.status = 2;
                _this.$nextTick(() => {
                    up.bind("FilesAdded", function (up, file) {
                        _this.detailData.order_work.status = 2;
                    });
                    up.bind("UploadComplete", function (up, file) {
                        let data = {
                            url: _this.$refs.uploader.fileList[0].key,
                            work_id: _this.detailData.order_work.wid,
                            order_id: _this.detailData.order_work.order_id
                        };
                        addWork3D(data).then(res=>{
                            if (res.code === 1){
                                _this.detailData.order_work.status = 1;
                            } else {
                                _this.detailData.order_work.status = 3;
                            }
                            // 刪除上傳檔案
                            up.removeFile(up.files[0]);
                        }).catch(err=>{
                            _this.detailData.order_work.status = 3;
                            // 刪除上傳檔案
                            up.removeFile(up.files[0]);
                        });
                    });
                    up.bind("Error", function (up, err) {
                        _this.detailData.order_work.status = 3;
                    });
                });
            }
        }
    }
</script>

<style lang="less" scoped>
.order-detail-wrap{
    background-color: #ffffff;
    padding: 20px;
    .mar-top20{
        margin-top: 20px;
    }
    .detail-title{
        font-size: 16px;
        color: #000;
        border-bottom: 1px solid #eeeeee;
        padding-bottom: 8px;
        margin-bottom: 20px;
    }
    .detail-content{
        .list{
            display: flex;
            align-items: center;
            margin-bottom: 12px;
            label{
                flex-shrink: 0;
                width: 80px;
                color: #aaa;
            }
            .con{
                color: #222;
                .tips{
                    color: #aaa;
                }
            }
        }
    }
    .invoicing-btn{
        margin-left: 80px;
    }
}
</style>